import { UserInfoEntity } from "@/domain/entity/user-info-entity";
import { getRoleFromString } from "@/utils/enum/user-role";
import { assertUserInfoResponseDto } from "@/utils/validation/user-info-validator";
import { UserInfoResponseDto } from "../dto/user-info-response-dto";

export class UserInfoMapper {
  static toEntity(userInfo: UserInfoResponseDto): UserInfoEntity {
    // Typia 스타일 타입 기반 검증 (assert<T>와 동일)
    console.log("[UserInfoMapper] :: toEntity :: 입력 데이터:", JSON.stringify(userInfo, null, 2));
    assertUserInfoResponseDto(userInfo);

    const hospitalInfo =
      userInfo.hospitalCode && userInfo.hospitalName
        ? {
            code: userInfo.hospitalCode,
            name: userInfo.hospitalName,
          }
        : undefined;

    const newRole = getRoleFromString(userInfo.role);

    return {
      fullName: userInfo.fullName,
      hospitalInfo: hospitalInfo,
      role: newRole,
    };
  }
}
